/***
 const scrollToSmooth = element => {
  console.log("element to scroll to", element);
  let start = null;
  const target = element && element ? 100 : 0; //element.getBoundingClientRect().top : 0;
  const firstPos = window.pageYOffset || document.documentElement.scrollTop;
  let pos = 0;

  console.log("Element", element, target, element.clientTop, firstPos, pos);

  (function() {
    var browser = ["ms", "moz", "webkit", "o"];

    for (let x = 0, length = browser.length; x < length && !window.requestAnimationFrame; x++) {
      window.requestAnimationFrame = window[browser[x] + "RequestAnimationFrame"];
      window.cancelAnimationFrame = window[browser[x] + "CancelAnimationFrame"] || window[browser[x] + "CancelRequestAnimationFrame"];
    }
  })();

  function showAnimation(timestamp) {
    console.log("show animation", timestamp, start);
    if (!start) {
      start = timestamp || new Date().getTime();
    } //get id of animation

    let elapsed = timestamp - start;
    let progress = elapsed / 800; // animation duration 600ms

    //ease in function from https://github.com/component/ease/blob/master/index.js
    const outQuad = function(n) {
      return n * (2 - n);
    };

    let easeInPercentage = +outQuad(progress).toFixed(2);

    // if target is 0 (back to top), the position is: current pos + (current pos * percentage of duration)
    // if target > 0 (not back to top), the positon is current pos + (target pos * percentage of duration)
    pos = target === 0 ? firstPos - firstPos * easeInPercentage : firstPos + target * easeInPercentage;

    window.scrollTo(0, pos);

    if ((target !== 0 && pos >= firstPos + target) || (target === 0 && pos >= 0)) {
      cancelAnimationFrame(start);
      console.log("cancel animation", start, target, firstPos, pos);
      if (element) {
        element.setAttribute("tabindex", -1);
      }
      pos = 0;
    } else {
      window.requestAnimationFrame(showAnimation);
    }
  }
  window.requestAnimationFrame(showAnimation);
};

**/

export const scrollToSmoothByPosition = (top, isLast = false, duration = 400) => {
  const startPos = window.pageYOffset;
  const diff = top - startPos;

  scrollAnimation(startPos, diff, duration);
};

export const scrollToSmooth = (element, duration = 400) => {
  const startPos = window.pageYOffset;
  var diff = element.getBoundingClientRect()?.top;

  // scroll 60px extra upp to not be covered by header.
  diff -= 60;

  scrollAnimation(startPos, diff, duration);
};

export const scrollToSmoothPDP = (target, isLast = false, duration = 400) => {
  const top = target.getBoundingClientRect().top;
  const startPos = window.pageYOffset;
  const diff = !isLast ? top - 160 : top - 200;

  scrollAnimation(startPos, diff, duration);
};

const scrollAnimation = (startPos, diff, duration = 400) => {
  let startTime = null;
  let requestId;

  const loop = function(currentTime) {
    if (!startTime) {
      startTime = currentTime;
    }

    // Elapsed time in miliseconds
    const time = currentTime - startTime;
    const percent = Math.min(time / duration, 1);
    const easeInQuad = function(t) {
      return t * t;
    };
    window.scrollTo(0, startPos + diff * easeInQuad(percent));

    if (time < duration) {
      // Continue moving
      requestId = window.requestAnimationFrame(loop);
    } else {
      window.cancelAnimationFrame(requestId);
    }
  };
  requestId = window.requestAnimationFrame(loop);
};

export const scrollToSmoothTryMultipleTimes = id => {
  var element = document.getElementById(id);

  if (element === null) {
    setTimeout(function() {
      element = document.getElementById(id);
      if (element === null) {
        setTimeout(function() {
          element = document.getElementById(id);
          if (element === null) {
            setTimeout(function() {
              element = document.getElementById(id);
              element && scrollToSmooth(element);
            }, 500);
          } else {
            scrollToSmooth(element);
          }
        }, 500);
      } else {
        scrollToSmooth(element);
      }
    }, 500);
  } else {
    scrollToSmooth(element);
  }
};

export const scrollToSmoothTryMultipleTimesByDataSourceid = id => {
  var element = document.querySelector(`[datasourceid="${id}"]`);
  if (element === null) {
    setTimeout(function() {
      element = document.querySelector(`[datasourceid="${id}"]`);
      if (element === null) {
        setTimeout(function() {
          element = document.querySelector(`[datasourceid="${id}"]`);
          if (element === null) {
            setTimeout(function() {
              element = document.querySelector(`[datasourceid="${id}"]`);
              element && scrollToSmooth(element);
            }, 500);
          } else {
            scrollToSmooth(element);
          }
        }, 500);
      } else {
        scrollToSmooth(element);
      }
    }, 500);
  } else {
    scrollToSmooth(element);
  }
};